import { useEffect } from 'react';
import nav_icon_income_protection from '../../assets/nav-income-protection.png';
import nav_icon_health_insurance from '../../assets/icon_health_insurance.svg';
import nav_icon_health_cash from '../../assets/icon-health-cash.svg';
import nav_icon_credit_life from '../../assets/nav-credit-life.svg';
import nav_icon_casava_dairy from '../../assets/nav_casava_dairy.svg';
import nav_icon_casava_hand from '../../assets/nav_casava_hand.svg';
import nav_icon_discount from '../../assets/nav_discount.svg';
function Header() {
  useEffect(() => {});
  const openMobileMenu = (event, param) => {
    document.getElementById('mobileDropdown').classList.toggle('show');
  };
  const closeMobileMenu = (event, param) => {
    document.getElementById('mobileDropdown').classList.remove('show');
  };

  const openMenuList = (event, param) => {
    if (param === 'menu-products') {
      var businessMenu = document.getElementById('menu-business');
      var productsMenu = document.getElementById(param);
      productsMenu.classList.add('active');
      businessMenu.classList.remove('active');
    } else if (param === 'menu-resoures') {
      document.getElementById(param).classList.toggle('show');
    }
  };

  const openLearnList = (event, param) => {
    if (param === 'menu-learn') {
      var element = document.getElementById(param);
      element.classList.add('active');
    } else if (param === 'menu-learn') {
      document.getElementById(param).classList.toggle('show');
    }
  };
  const openBusinessList = (event, param) => {
    if (param === 'menu-business') {
      var productsMenu = document.getElementById('menu-products');
      var businessMenu = document.getElementById(param);
      businessMenu.classList.add('active');
      productsMenu.classList.remove('active');
    } else if (param === 'menu-business') {
      document.getElementById(param).classList.toggle('show');
    }
  };
  return (
    <>
      {/* navigation header section  */}
      <nav className="site-header sticky">
        <div className="nav-menu">
          <div>
            <div className="logo">
              <a href="/landing" title="Casava" aria-label="Casava">
                <svg
                  width="132"
                  height="30"
                  viewBox="0 0 132 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M57.994 9.403c1.307 0 1.647 1.142 1.647 1.935 0 .836-.441 1.874-.782 2.205h3.671c.504-.602 1.145-2.078 1.145-3.25-.007-2.519-1.718-5.084-5.822-5.084-3.383 0-6.059 1.36-6.516 4.543-.378 2.65.604 4.824 1.827 6.938 1.173 2.028.596 3.24-.617 3.24-2.121-.004-2.281-2.9-2.281-4.78h-2.467a11.02 11.02 0 00-.729 1.943c-.32.922-.62 2.805-1.876 2.805-1.857 0-.473-3.236.246-5.1.733-1.903 2.914-7.613 3.293-8.66h-7.138c.73 1.32.391 2.934-.109 3.55-.094-.966-.885-3.625-5.377-3.625-5.816 0-9.245 5.81-10.523 8.551-3.676 7.883-.522 13.236 3.835 13.236 5.773 0 7.105-4.784 7.232-5.245-.044.3.428 5.245 4.722 5.245 2.714 0 4.651-1.573 6.059-4.263.85 2.556 3.27 4.34 7.004 4.34 5.397 0 6.796-3.888 6.796-6.011 0-6.482-5.007-6.765-5.007-10.505.01-.754.453-2.008 1.767-2.008zm-18.66 6.652c-1.173 2.45-3.115 3.84-5.146 3.84-2.84 0-3.796-2.894-2.387-5.641 1.158-2.258 3.061-3.86 5.46-3.86 2.22 0 3.658 2.36 2.073 5.661zM12.861 19.904c-4.47 0-5.629-5.498-4.169-9.085 1.43-3.512 3.956-5.58 7.019-5.58 4.69 0 3.926 5.643 3.919 5.65h4.565C24.823 9.063 25.518 0 17.155 0 11.728 0 5.954 3.819 2.4 10.71-2.824 20.822.978 30 9.089 30c4.85 0 8.244-1.976 11.154-6.682 2.91-4.707 3.157-8.24 3.157-8.371l-4.359-.012c-.004.028-1.096 4.969-6.18 4.969zM125.478 19.904c-1.901 0-.215-3.242.491-5.111.758-2.018 2.824-7.614 3.203-8.652h-7.136c.73 1.32.391 2.937-.111 3.552-.092-.965-.885-3.624-5.375-3.624-5.816 0-9.247 5.81-10.525 8.55-3.676 7.885-.838 13.231 3.835 13.231 5.774 0 7.159-4.923 7.232-5.245-.102.573.604 5.245 5.425 5.245 8.027 0 8.475-12.002 8.475-12.002l-3.051-.02c-.279 1.05-1.065 4.076-2.463 4.076zm-5.705-3.841c-1.173 2.452-3.113 3.84-5.146 3.84-2.838 0-3.796-2.894-2.386-5.641 1.159-2.257 3.06-3.86 5.458-3.86 2.215 0 3.661 2.359 2.074 5.66zM103.162 6.135c-.252.601-1.495 3.512-3.208 7.323-1.58 3.514-3.127 6.446-5.228 6.446-2.494 0-2.114-2.659-.586-6.49 1.646-4.113 2.345-6.109 2.793-7.279h-7.056c-.092.244-2.797 7.524-3.041 8.18-.207.554-1.16 2.656-1.439 4.264-.205 1.186-.766 1.325-1.254 1.325-2.121 0-.731-2.938.094-5.105.758-2.004 2.826-7.614 3.205-8.658h-7.134c.729 1.32.39 2.937-.112 3.552-.091-.965-.885-3.624-5.374-3.624-5.817 0-9.247 5.81-10.525 8.55-3.677 7.885-.839 13.231 3.834 13.231 5.774 0 7.056-4.733 7.232-5.245-.092.575.471 5.245 5.299 5.245 2.654 0 4.886-2.55 5.369-5.105.217 2.316 2.683 5.12 5.84 5.12 6.088 0 8.271-4.028 11.961-11.59 3.444-7.056 4.691-9.77 4.869-10.142l-5.539.002zm-25.117 9.928c-1.173 2.452-3.114 3.84-5.147 3.84-2.837 0-3.795-2.894-2.386-5.641 1.159-2.257 3.06-3.86 5.459-3.86 2.209 0 3.66 2.359 2.074 5.66z"
                    fill="#FF147D"
                  ></path>
                </svg>
              </a>
            </div>

            <div className="hiring-cta">
              <a
                href="https://gocasava.notion.site/gocasava/Seeders-at-Casava-47266a1e056841dfa1b87d13b538c240"
                target="_blank"
                className="button button--black"
              >
                <span>We are Hiring 👋</span>
              </a>
            </div>
          </div>
          <div className="nav-menu__list hidden md:flex">
            <ul className="menu-items">
              <li className="web-dropdown">
                <span
                  className="menu-products-dropbtn"
                  onClick={(event) => openMenuList(event, 'menu-products')}
                >
                  Personal
                  <span style={{ zIndex: '-999' }}>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M16.431 6.119L10 12.556 3.569 6.12l-.888.887 6.875 6.875h.888l6.875-6.875-.888-.887z"></path>
                    </svg>
                  </span>
                </span>

                <ul id="menu-products" className="menu-products-dropdown">
                  {/* <li>
                                    <a href="/income-protection" aria-label="Income Protection">
                                        <span className="nav-icon"><img src={nav_icon_income_protection} alt="Income Protection" /></span>
                                        <span className="nav-title">Income Protection</span>
                                        <span className="nav-description">Maintain your lifestyle and income even if you lose your job</span>
                                    </a>
                                </li> */}
                  <li>
                    <a href="/health-insurance" aria-label="Health Insurance">
                      <span className="nav-icon">
                        <img
                          src={nav_icon_health_insurance}
                          alt="Health Insurance"
                        />
                      </span>
                      <span className="nav-title">Health Insurance</span>
                      <span className="nav-description">
                        Enjoy affordable healthcare without breaking the bank
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="/health-cash" aria-label="Health Cash">
                      <span className="nav-icon">
                        <img src={nav_icon_health_cash} alt="Health Cash" />
                      </span>
                      <span className="nav-title">Health Cash</span>
                      <span className="nav-description">
                        Get cash back for every visit to the hospital
                      </span>
                    </a>
                  </li>
                  {/* <li>
                                    <a href="/credit-life" aria-label="Credit Life">
                                        <span className="nav-icon"><img src={nav_icon_credit_life} alt="Credit Life" /></span>
                                        <span className="nav-title">Credit Life</span>
                                        <span className="nav-description">Build sustainable businesses with Credit Insurance</span>
                                    </a>
                                </li> */}
                </ul>
              </li>
              <li className="web-dropdown">
                <span
                  className="menu-products-dropbtn"
                  onClick={(event) => openBusinessList(event, 'menu-business')}
                >
                  Business
                  <span style={{ zIndex: '-999' }}>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M16.431 6.119L10 12.556 3.569 6.12l-.888.887 6.875 6.875h.888l6.875-6.875-.888-.887z"></path>
                    </svg>
                  </span>
                </span>

                <ul id="menu-business" className="menu-products-dropdown">
                  <li>
                    <a href="/credit-life" aria-label="Credit Life">
                      <span className="nav-icon">
                        <img src={nav_icon_credit_life} alt="Credit Life" />
                      </span>
                      <span className="nav-title">Credit Life</span>
                      <span className="nav-description">
                        Build Sustainable business with Credit Life
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="/business-gro" aria-label="Business Gro">
                      <span className="nav-icon">
                        <img src={nav_icon_casava_dairy} alt="Business Gro" />
                      </span>
                      <span className="nav-title">Business Gro</span>
                      <span className="nav-description">
                        Grow your business with <br />
                        Business Gro
                      </span>
                    </a>
                  </li>
                  {/* <li>
                                    <a href="#" aria-label="MSME Business Insurance">
                                        <span className="nav-icon"><img src={nav_icon_casava_hand} alt="MSME Business Insurance" /></span>
                                        <span className="nav-title">MSME Business Insurance</span>
                                        <span className="nav-description">Protect business property against fire and flood.</span>
                                    </a>
                                </li> */}
                  {/* <li>
                                    <a href="#" aria-label="POS Insurance">
                                        <span className="nav-icon"><img src={nav_icon_discount} alt="POS Insurance" /></span>
                                        <span className="nav-title">POS Insurance</span>
                                        <span className="nav-description">Cover POS device against risk of loss and damage</span>
                                    </a>
                                </li> */}
                </ul>
              </li>
              {/* <li><a href="/business">Business</a></li> */}
              <li>
                <a href="/partners" aria-label="Partners">
                  Partners
                </a>
              </li>
              <li>
                <a href="/claims" aria-label="Claims">
                  Claims
                </a>
              </li>
              <li className="web-dropdown">
                <span
                  className="menu-learn-dropbtn"
                  onClick={(event) => openLearnList(event, 'menu-learn')}
                >
                  Learn
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M16.431 6.119L10 12.556 3.569 6.12l-.888.887 6.875 6.875h.888l6.875-6.875-.888-.887z"></path>
                  </svg>
                </span>

                <ul id="menu-learn" className="menu-learn-dropdown">
                  {/* <li><a href="">FAQ <span class="badge">COMING SOON</span></a></li> */}
                  <li>
                    <a
                      href="https://casava1.zohodesk.com/portal/en/kb"
                      aria-label="FAQ"
                    >
                      FAQ
                    </a>
                  </li>
                  {/* <li><a href="https://faq.casava.com/" aria-label="FAQ" >FAQ</a></li> */}
                  <li>
                    <a
                      href="https://www.blog.casava.com/"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Blog"
                    >
                      Blog
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
            <div className="cta-area flex">
              <a
                className="button button--pink-light"
                href="https://insurance.casava.co/auth/login/"
                target="_blank"
                rel="noreferrer"
                aria-label="Login"
              >
                <span>Log In</span>
              </a>
              <a
                className="button button--pink"
                href="https://insurance.casava.co/signup"
                target="_blank"
                rel="noreferrer"
                aria-label="Sign Up"
              >
                <span>Sign Up</span>
              </a>
            </div>
          </div>

          <div className="mobile-menu">
            <div className="mobile-dropdown">
              <button
                className="mobile-menu__trigger dropbtn"
                onClick={() => openMobileMenu()}
                aria-label="mobile nav"
              >
                <span></span>
              </button>
              <div>
                <ul id="mobileDropdown" className="dropdown-content">
                  <span onClick={() => closeMobileMenu()}></span>
                  <li>
                    <strong>Personal</strong>
                    <ul className="mt-4 sub-menu-inner">
                      {/* <li>
                                            <a href="/income-protection" aria-label="Income Protection">
                                                <img src={nav_icon_income_protection} className="icon-mob-nav" alt="Income Protection" />
                                                <strong>Income Protection</strong> <br/>
                                                <small>Maintain your lifestyle and income even if you lose your job</small>
                                            </a>
                                        </li> */}
                      <li>
                        <a
                          href="/health-insurance"
                          aria-label="Health Insurance"
                        >
                          <img
                            src={nav_icon_health_insurance}
                            className="icon-mob-nav"
                            alt="Health Insurance"
                          />
                          <strong>Health Insurance</strong> <br />
                          <small>
                            Enjoy affordable healthcare without breaking the
                            bank
                          </small>
                        </a>
                      </li>
                      <li>
                        <a href="/health-cash" aria-label="Health Cash">
                          <img
                            src={nav_icon_health_cash}
                            className="icon-mob-nav"
                            alt="Health Cash"
                          />
                          <strong>Health Cash</strong> <br />
                          <small>
                            Get cash back for every visit to the hospital
                          </small>
                        </a>
                      </li>
                      {/* <li>
                                            <a href="/credit-life" aria-label="Credit Life">
                                                <img src={nav_icon_credit_life} className="icon-mob-nav" alt="Credit Life" />
                                                <strong>Credit Life</strong><br/>
                                                <small>Build sustainable businesses with Credit Insurance</small>
                                            </a>
                                        </li> */}
                    </ul>
                    {/* <a href="/business"><strong className="block mt-8">Business</strong></a> */}
                    <a href="/partners" aria-label="partners">
                      <strong className="block mt-8">Partners</strong>
                    </a>
                    <a href="/claims" aria-label="claims">
                      <strong className="block mt-8">Claims</strong>
                    </a>
                    {/* <a href=""><strong className="block mt-8">FAQ <small class="mob-nav-badge">COMING SOON</small></strong> </a> */}
                    <a href="https://casava1.zohodesk.com/portal/en/kb">
                      <strong className="block mt-8">FAQ</strong>{' '}
                    </a>
                    {/* <a href="https://faq.casava.com/"><strong className="block mt-8">FAQ</strong> </a> */}
                    <a href="https://www.blog.casava.com/" target="_blank">
                      <strong className="block mt-8">Blog</strong>
                    </a>
                    <strong className="block mt-8">More</strong>
                    <ul className="mt-4">
                      <li>
                        <a
                          href="https://insurance.casava.co/auth/login/"
                          aria-label="Login"
                        >
                          Login
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://insurance.casava.co"
                          aria-label="Sign Up"
                        >
                          Sign Up
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
